import { Component, OnInit } from '@angular/core';
import { UserPermission } from 'src/app/enums/enums';
import { Sections } from 'src/app/enums/sections';
import { RoleService } from 'src/app/services/core/role/role.service';

@Component({
  selector: 'app-sections-permissions-grid',
  templateUrl: './sections-permissions-grid.component.html',
  styleUrls: ['./sections-permissions-grid.component.css']
})
export class SectionsPermissionsGridComponent implements OnInit {
  search: any = '';
  roles: any;
  rolesById: any;
  sections: any = Sections;

  constructor(
    private roleService: RoleService
  ) { }

  ngOnInit() {
    this.getRoles();
  }

  getRoles() {
    const queryParams = {
      isActive: true,
      limit: 9999
    }
    this.roleService
      .getPickerRoles(queryParams)
      .subscribe((data: any) => {
        if (data && data.results && data.results.length) {
          const roles = data.results;
          this.rolesById = roles.reduce((acc: any, role: any) => {
            acc[role.id] = {
              id: role.id,
              name: role.name,
              permissions: role.permissions,
              sections: this.getSections(role.permissions),
              hasAllPermissions: this.hasAllPermissions(role.permissions)
            };
            return acc;
          }, {});
          this.roles = roles;
        }
      })
  }

  getSections(existing_permissions: any) {
    const required_permissions = this.getSectionsRequiredPermissions();
    return {
      [Sections.SIGNUPS]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.SIGNUPS].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.SIGNUPS].manage)
      },
      [Sections.ONBOARDING]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING].manage)
      },
      [Sections.ONBOARDING_DASHBOARD]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_DASHBOARD].view)
      },
      [Sections.ONBOARDING_CONFIGURATION]: {
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_CONFIGURATION].manage)
      },
      [Sections.ONBOARDING_COMPANY]: {
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_COMPANY].manage)
      },
      [Sections.ONBOARDING_DRIVERS]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_DRIVERS].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_DRIVERS].manage)
      },
      [Sections.ONBOARDING_VEHICLES]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_VEHICLES].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_VEHICLES].manage)
      },
      [Sections.ONBOARDING_RATES]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_RATES].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_RATES].manage)
      },
      [Sections.ONBOARDING_THRESHOLD]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_THRESHOLD].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.ONBOARDING_THRESHOLD].manage)
      },
      [Sections.DASHBOARD]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.DASHBOARD].view)
      },
      [Sections.TRIPS]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.TRIPS].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.TRIPS].manage)
      },
      [Sections.LEVEL_OF_SERVICE]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.LEVEL_OF_SERVICE].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.LEVEL_OF_SERVICE].manage)
      },
      [Sections.SPACE_TYPE]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.SPACE_TYPE].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.SPACE_TYPE].manage)
      },
      [Sections.APPOINTMENT_TYPE]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.APPOINTMENT_TYPE].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.APPOINTMENT_TYPE].manage)
      },
      [Sections.ADDONS]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.ADDONS].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.ADDONS].manage)
      },
      [Sections.SERVICE_AREA]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.SERVICE_AREA].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.SERVICE_AREA].manage)
      },
      [Sections.CHANGE_REASON]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.CHANGE_REASON].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.CHANGE_REASON].manage)
      },
      [Sections.PLACE_TYPE]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.PLACE_TYPE].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.PLACE_TYPE].manage)
      },
      [Sections.QUICKBOOKS_CONFIG]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.QUICKBOOKS_CONFIG].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.QUICKBOOKS_CONFIG].manage)
      },
      [Sections.MEMBER]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.MEMBER].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.MEMBER].manage)
      },
      [Sections.FUNDING_SOURCE]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.FUNDING_SOURCE].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.FUNDING_SOURCE].manage)
      },
      [Sections.USER]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.USER].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.USER].manage)
      },
      [Sections.STATISTICS]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.STATISTICS].view),
      },
      [Sections.BILLING]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.BILLING].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.BILLING].manage)
      },
      [Sections.ROLES]: {
        view: this.hasPermission(existing_permissions, required_permissions[Sections.ROLES].view),
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.ROLES].manage)
      },
      [Sections.QUICKBOOKS]: {
        manage: this.hasPermission(existing_permissions, required_permissions[Sections.QUICKBOOKS].manage)
      },
    }
  }

  hasPermission(existing: any, required: any) {
    return required.every((r: any) => existing.includes(r));
  }

  getSectionsRequiredPermissions() {
    return {
      [Sections.SIGNUPS]: {
        view: [
          UserPermission.GET_SIGNUP
        ],
        manage: [
          UserPermission.MANAGE_SIGNUP,
          UserPermission.MANAGE_COMPANY
        ]
      },
      [Sections.ONBOARDING]: {
        view: [
          UserPermission.GET_ONBOARDING
        ],
        manage: [
          UserPermission.MANAGE_ONBOARDING,
          UserPermission.GET_COMPANY,
          UserPermission.MANAGE_COMPANY,
          UserPermission.GET_COMPANY_CONFIGURATION,
          UserPermission.MANAGE_COMPANY_CONFIGURATION
        ]
      },
      [Sections.ONBOARDING_DASHBOARD]: {
        view: [
          UserPermission.GET_THRESHOLD_DASHBOARD
        ]
      },
      [Sections.ONBOARDING_CONFIGURATION]: {
        manage: [
          UserPermission.GET_COMPANY_CONFIGURATION,
          UserPermission.MANAGE_COMPANY_CONFIGURATION
        ]
      },
      [Sections.ONBOARDING_COMPANY]: {
        manage: [
          UserPermission.MANAGE_COMPANY
        ]
      },
      [Sections.ONBOARDING_DRIVERS]: {
        view: [
          UserPermission.GET_DRIVER
        ],
        manage: [
          UserPermission.MANAGE_DRIVER
        ]
      },
      [Sections.ONBOARDING_VEHICLES]: {
        view: [
          UserPermission.GET_VEHICLE
        ],
        manage: [
          UserPermission.MANAGE_VEHICLE
        ]
      },
      [Sections.ONBOARDING_RATES]: {
        view: [
          UserPermission.GET_FARES
        ],
        manage: [
          UserPermission.MANAGE_FARES
        ]
      },
      [Sections.ONBOARDING_THRESHOLD]: {
        view: [
          UserPermission.GET_THRESHOLD
        ],
        manage: [
          UserPermission.MANAGE_THRESHOLD
        ]
      },
      [Sections.DASHBOARD]: {
        view: [
          UserPermission.GET_TRIP, 
          UserPermission.GET_DRIVRER_ACTIVITY
        ]
      },
      [Sections.TRIPS]: {
        view: [
          UserPermission.GET_TRIP
        ],
        manage: [
          UserPermission.MANAGE_TRIP,
          UserPermission.GET_COMPANY,
          UserPermission.GET_THRESHOLD_DASHBOARD,
          UserPermission.MANAGE_EVENT,
          UserPermission.MANAGE_BILLINGS
        ]
      },
      [Sections.LEVEL_OF_SERVICE]: {
        view: [
          UserPermission.GET_LOS
        ],
        manage: [
          UserPermission.MANAGE_LOS
        ]
      },
      [Sections.SPACE_TYPE]: {
        view: [
          UserPermission.GET_SPACE_TYPE
        ],
        manage: [
          UserPermission.MANAGE_SPACE_TYPE
        ]
      },
      [Sections.APPOINTMENT_TYPE]: {
        view: [
          UserPermission.GET_APPOINTMENT_TYPE
        ],
        manage: [
          UserPermission.MANAGE_APPOINTMENT_TYPE
        ]
      },
      [Sections.ADDONS]: {
        view: [
          UserPermission.GET_ADDON
        ],
        manage: [
          UserPermission.MANAGE_ADDON
        ]
      },
      [Sections.SERVICE_AREA]: {
        view: [
          UserPermission.GET_SERVICE_AREAS
        ],
        manage: [
          UserPermission.MANAGE_SERVICE_AREAS
        ]
      },
      [Sections.CHANGE_REASON]: {
        view: [
          UserPermission.GET_CHANGE_REASON
        ],
        manage: [
          UserPermission.MANAGE_CHANGE_REASON
        ]
      },
      [Sections.PLACE_TYPE]: {
        view: [
          UserPermission.GET_PLACE_TYPES
        ],
        manage: [
          UserPermission.MANAGE_PLACE_TYPES
        ]
      },
      [Sections.QUICKBOOKS_CONFIG]: {
        view: [
          UserPermission.GET_CONFIGURATION
        ],
        manage: [
          UserPermission.MANAGE_CONFIGURATION
        ]
      },
      [Sections.MEMBER]: {
        view: [
          UserPermission.GET_MEMBER,
          UserPermission.GET_MEMBER_TRIP
        ],
        manage: [
          UserPermission.MANAGE_MEMBER
        ]
      },
      [Sections.FUNDING_SOURCE]: {
        view: [
          UserPermission.GET_FUNDING_SOURCE,
        ],
        manage: [
          UserPermission.GET_FARES,
          UserPermission.MANAGE_FUNDING_SOURCE
        ]
      },
      [Sections.USER]: {
        view: [
          UserPermission.GET_USERS,
        ],
        manage: [
          UserPermission.MANAGE_USERS
        ]
      },
      [Sections.STATISTICS]: {
        view: [
          UserPermission.GET_TRIP,
        ]
      },
      [Sections.BILLING]: {
        view: [
          UserPermission.GET_BILLINGS,
        ],
        manage: [
          UserPermission.MANAGE_BILLINGS,
          UserPermission.MANAGE_EVENT
        ]
      },
      [Sections.ROLES]: {
        view: [
          UserPermission.GET_ROLE,
        ],
        manage: [
          UserPermission.MANAGE_ROLE
        ]
      },
      [Sections.QUICKBOOKS]: {
        manage: [
          UserPermission.MANAGE_QUICKBOOKS
        ]
      },
    }
  }

  onChangeViewPermission(role: any, section: any, evt: Event) {
    const required = (this.getSectionsRequiredPermissions() as any)[section].view;
    this.savePermissions(role, required, evt);
  }

  onChangeManagePermission(role: any, section: any, evt: Event) {
    const required = (this.getSectionsRequiredPermissions() as any)[section].manage;
    this.savePermissions(role, required, evt);
  }

  savePermissions(role: any, required: any, evt: any) {
    const existing = role.permissions;
    let newPermissions : any;
    if (evt) {
      newPermissions = Array.from(new Set([...existing, ...required]));
    } else {
      newPermissions = existing.filter((permission: any) => !required.includes(permission));
    }
    const payload = {
      permissions: newPermissions
    }
    this.apiRequest(role.id, payload); 
  }

  apiRequest(roleId: any, payload: any) {
    this.roleService
      .saveUser(roleId, payload)
      .subscribe(data => {
        if (data) {
          this.rolesById[roleId].permissions = payload.permissions;
          this.rolesById[roleId].sections = this.getSections(payload.permissions);
          this.rolesById[roleId].hasAllPermissions = this.hasAllPermissions(payload.permissions)
        }
      });
  }

  onSelectAll(roleId: any, evt: Event) {
    const permissions = this.getAllSectionsPermissions();
    if (evt) {
      this.apiRequest(roleId, {permissions});
    } else {
      this.apiRequest(roleId, {permissions: []});
    }
  }

  getAllSectionsPermissions() {
    let permissions: any = [];
    const sectionPermissions = (this.getSectionsRequiredPermissions() as any);
    Object.keys(sectionPermissions).forEach((section: any) => {
      const view = sectionPermissions[section] && sectionPermissions[section].view ? sectionPermissions[section].view : [];
      const manage = sectionPermissions[section] && sectionPermissions[section].manage ? sectionPermissions[section].manage : [];
      permissions = [...permissions, ...view, ...manage];
    });

    return permissions = Array.from(new Set([...permissions]));
  }

  hasAllPermissions(existingPermissions: any) {
    const allSectionsPermissions = this.getAllSectionsPermissions();
    return allSectionsPermissions.every(permission => existingPermissions.includes(permission));
  }

}
